<template>

<nav
    :type="type"
      class="
        w-full,
        w-4/12
      "
/>
    <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Cabeçalho - CMS</h3>

    <nav class="w-4/12 px-2 py-3 bg-primary mb-3">
        <div class="container px-4 mx-auto flex flex-wrap items-center">
            <a class="text-xl font-bold mr-4 py-2 text-white">
                {{tituloDaCampanha}} Cabeçalho
            </a> 
        </div>
    </nav>
</template>
